var exports = {
  "G": "xe7b6e3d6--8fdbb0--social-links",
  "W": "xe7b6e3d6--8fdbb0--input-link",
  "vk": "xe7b6e3d6--8fdbb0--vk",
  "ok": "xe7b6e3d6--8fdbb0--ok",
};

module.exports = exports;
